module.exports = __webpack_public_path__ + "img/join-plus-1.4398333.png";